<template>
    <div>  
      <template v-if="blog">
        <section class="mb-24">
          <UiHeroTop :article="blogStore.filterArticlesByTag(blog, 'Herobanner')[0]" />
        </section>
        <UiContentwrapper>
          <UiFullcolumn>
            <!-- Articles Grid -->
            <TransitionGroup name="fade-slide" tag="div" class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
              <!-- Loop over filtered articles (excluding "Excluded" tag) -->
              <div v-for="article in visibleArticles" :key="article.handle" class="w-full group article-hover">
                <!-- Article Image -->
                  <UiArticleImage 
                    v-if="article.image"
                    :article="article"
                    class="w-full article-image"
                    :modifiers="{
                      auto: 'format,compress',
                      fit: 'crop',
                      crop: 'faces,edges',
                      ar: '364:243'
                    }"
                  />
  
                <!-- Article Title -->
                <div class="relative mt-5">
                    <h4 class="m-0 pb-1">
                      {{ article.title }}
                    </h4>
                    <div class="excerpt xsmall mt-1" v-html="cleanHtml(article.excerpthtml)"></div>
                </div>
              </div>
            </TransitionGroup>

            <!-- Show more button -->
            <div v-if="filteredArticles.length > 9" class="mt-6 text-center">

              <UiRippleButton @click="showAllStores = !showAllStores">
                {{ showAllStores ? 'Show Less' : 'Show More' }}
              </UiRippleButton>
            </div>
          </UiFullcolumn>

          <!-- Map Section-->
          <UiFullcolumn>
            <MapsSuppliers />
          </UiFullcolumn>
        </UiContentwrapper>
        
  
      </template>
    </div>
</template>
  
<script setup>
import { computed } from 'vue';
import { useBlogStore } from '@/stores/blogStore';
const blogStore = useBlogStore();

const props = defineProps({
  blog: {
    type: Object,
    required: true
  }
});

// Remove articles that include the tag 'Excluded'
const filteredArticles = computed(() => {
  return props.blog.articles?.filter(article => {
    return !article.tags?.includes('Excluded');
  }) || [];
});

const showAllStores = ref(false);
const visibleArticles = computed(() => {
  return showAllStores.value ? filteredArticles.value : filteredArticles.value.slice(0, 9);
});


const blogHandle = computed(() => props.blog.handle);

// Function to clean HTML content, keeping only allowed tags
const cleanHtml = (html) => {
  if (!html) return '';

  // Remove <meta> tags
  html = html.replace(/<meta[^>]*>/gi, '');

  // Allowed tags
  const allowedTags = ['p', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'ul', 'ol', 'li', 'strong', 'em', 'a', 'br'];

  // Strip disallowed tags
  const regex = /<\/?([a-z][a-z0-9]*)[^>]*>/gi;
  const cleaned = html.replace(regex, (match, tag) =>
    allowedTags.includes(tag.toLowerCase()) ? match : ''
  );

  // If no block tags left, wrap it in a <p>
  if (!/<(p|ul|ol|h\d|div)/i.test(cleaned)) {
    return `<p>${cleaned}</p>`;
  }

  return cleaned;
};
</script>
  
<style>
@reference "../../assets/css/main.css";
.excerpt p,
.excerpt a,
.excerpt span {
  @apply text-xs lg:text-sm;
  font-variation-settings: 'wght' 310, 'wdth' 100, 'slnt' 0;
  line-height: 1.4;
}

/* Link color override */
.excerpt a {
  color: #7D5B1C;
}

@media (max-width: 640px) { /* Small screens */

  .mb-24 {
    margin-bottom: 32px; /* Adjusted for small screens */
  }
}


.fade-slide-enter-active,
.fade-slide-leave-active {
  transition: all 0.5s ease;
}

.fade-slide-enter-from {
  opacity: 0;
  transform: translateY(20px);
}

.fade-slide-enter-to {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-leave-from {
  opacity: 1;
  transform: translateY(0);
}

.fade-slide-leave-to {
  opacity: 0;
  transform: translateY(20px);
}


</style>
  